import { Epic } from '../shared'
import { ThisConnector } from '../../../../../api/connector'
import { BugtrackerRequest } from '../../../bugtrackers/api/shared'
import { buildApiPayloadBugtrackerCredentials } from '../../../bugtrackers/api/build-api-payload-bugtracker-credentials'

export interface GetEpicsArgs {
  organizationUuid?: string
  bugtrackerRequest: BugtrackerRequest | null
  bugtrackerId?: number
  projectKey?: string
  epicSearch?: string
}

export interface GetEpicsResponse {
  data: Epic[]
}

export async function getEpics(
  this: ThisConnector,
  {
    organizationUuid,
    bugtrackerRequest,
    bugtrackerId,
    projectKey,
    epicSearch
  }: GetEpicsArgs
) {
  if (!projectKey) {
    throw new Error(
      'Unable to fetch JIRA epics. Project Key cannot be undefined.'
    )
  }

  // Intentially a post request. Not a mistake
  const { data } = await this.connector.post<GetEpicsResponse>(
    bugtrackerId
      ? `/${organizationUuid}/bugtrackers/jira/${bugtrackerId}/projects/${projectKey}/epics?expand=skip_links`
      : `/${organizationUuid}/bugtrackers/jira/projects/${projectKey}/epics?expand=skip_links`,
    { ...buildApiPayloadBugtrackerCredentials(bugtrackerRequest), epicSearch }
  )
  return data
}
